export default __webpack_public_path__ + "static/media/PrizeBooster_159x150.ecb7ce0e.png";